// extracted by mini-css-extract-plugin
module.exports = {"browser-button":"styles-module__browser-button___2CxRL","placeholder":"styles-module__placeholder____aiys","placeholder-input":"styles-module__placeholder-input___Y_n50"};